import Link from 'next/link';
import Image from 'next/image';

import { CategoryCardType } from '../../../types/content';

/* eslint-disable-next-line */

export function NewsCard(props: CategoryCardType) {
  const { ctaLink, description, src, title } = props;

  return (
    <div className="flex flex-col lg:flex-row">
      <div className="block h-full w-full lg:w-4/12">
        <Image
          alt={title}
          blurDataURL="/icons/blur-placeholder.png"
          height={50}
          layout="responsive"
          objectFit="cover"
          placeholder="blur"
          src={src}
          width={75}
        />
      </div>
      <div className="flex flex-col font-MuseoSans100 pl-0 lg:pl-8 lg:w-8/12">
        <h6 className="text-body font-MuseoSans300 font-bold mt-6 lg:mt-0">
          {title}
        </h6>
        <p className="text-subtitle xl:text-[13px] font-extralight mt-3">
          {description}
        </p>
        <Link href={ctaLink} passHref>
          <a className="text-subtitle xl:text-[13px] font-extralight mt-3 underline hover:text-primaryBlue">
            READ MORE &gt;
          </a>
        </Link>
      </div>
    </div>
  );
}

export default NewsCard;
